import React from 'react';
import PropTypes from 'prop-types';

import './classrooms.scss';

export default function Classrooms({children}) {
  return <div className='classrooms'>{children && React.cloneElement(children, {})}</div>;
}

Classrooms.propTypes = {
  children: PropTypes.element
};
